"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4693],{

/***/ 6322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uu": function() { return /* binding */ SurveyThemeProvider; },
/* harmony export */   "tF": function() { return /* binding */ createSurveyStyles; },
/* harmony export */   "u7": function() { return /* binding */ useSurveyTheme; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1928);
/* harmony import */ var react_jss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(389);

function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


/** Create a React context which JSS would need to wrap on */ var SurveyThemeContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
SurveyThemeContext.displayName = "SurveyTheme";
/** Use JSS custom hook to create the wrapper */ var theming = (0,react_jss__WEBPACK_IMPORTED_MODULE_2__/* .createTheming */ .d5)(SurveyThemeContext);
/** Expose the associated hooks with aliases */ var useSurveyTheme = theming.useTheme, SurveyThemeProvider = theming.ThemeProvider;
/** Recreation of `react-jss`'s `CreateUseStylesOptions`, which is dynamic and does not get exported */ 
/**
 * For convenience, expose a custom hook which would carry the theming context wrapper along,
 * as well as injecting style sheet name-space / class name prefix as "sm" by default.
 *
 * Note: One may still utilize the stock `createUseStyles()` hook to construct styles regardless
 * relying on a survey theme or not; however if they do, please keep in mind that the recommended
 * way per JSS documentation is to pass in `theming` context wrapper every time.
 * ( https://cssinjs.org/react-jss/?v=v10.8.1#using-custom-theming-context )
 *
 */ var createSurveyStyles = function createSurveyStyles(styles) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0,react_jss__WEBPACK_IMPORTED_MODULE_3__/* .createUseStyles */ .QM)(styles, _objectSpread({
        theming: theming,
        name: "sm"
    }, opts));
};
/**
 * The context wrapper constructed by JSS `createTheming()` hook.
 * Note: `theming.context` points to the same SurveyThemeContext we just instantiated
 */ /* harmony default export */ __webpack_exports__["ZP"] = (theming); //# sourceMappingURL=context.js.map


/***/ }),

/***/ 3918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ defaultFontWeightOptions; }
/* harmony export */ });
var defaultFontWeightOptions = {
    ultralight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
};
// Collection of themes with unique font weights.
var fontInfo = [
    {
        fontName: "Montserrat",
        fontWeightOptions: {
            ultralight: 400,
            light: 400,
            regular: 400,
            medium: 400,
            bold: 700
        }
    },
    {
        fontName: "Open Sans Condensed",
        fontWeightOptions: {
            ultralight: 300,
            light: 300,
            regular: 300,
            medium: 300,
            bold: 700
        }
    }
];
var getFontWeights = function getFontWeights() {
    var fontFamily = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var fontItem = fontInfo.find(function(t) {
        return t.fontName === fontFamily.split(",")[0];
    });
    return fontItem ? fontItem.fontWeightOptions : defaultFontWeightOptions;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFontWeights); //# sourceMappingURL=getFontWeights.js.map


/***/ }),

/***/ 993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qu": function() { return /* binding */ formatTheme; }
/* harmony export */ });
/* unused harmony exports breakpoints, formatEntity, defaultNullToUndefined */
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2222);
/* harmony import */ var _wds_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4779);
/* harmony import */ var _isDark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2561);
/* harmony import */ var _getFontWeights__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3918);

var _excluded = [
    "__typename"
], _excluded2 = [
    "theme"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var fontStyleOption = {
    INHERIT: "inherit",
    INITIAL: "initial",
    ITALIC: "italic",
    NORMAL: "normal",
    OBLIQUE: "oblique"
};
var textDecorationOption = {
    NONE: "none",
    UNDERLINE: "underline"
};
var breakpoints = {
    "xxs": {
        "max": "480px"
    },
    "xs": {
        "min": "481px",
        "max": "640px"
    },
    "sm": {
        "min": "641px",
        "max": "768px"
    },
    "md": {
        "min": "769px",
        "max": "1024px"
    },
    "lg": {
        "min": "1025px",
        "max": "1200px"
    },
    "xl": {
        "min": "1201px"
    }
};
/** Possible Styles to format */ var formatStyle = function formatStyle(kvPair, styles) {
    switch(kvPair[0]){
        case "fontWeight":
            if (styles.fontFamily) {
                var fontWeights = (0,_getFontWeights__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles.fontFamily);
                return _defineProperty({}, kvPair[0], fontWeights[kvPair[1].toLowerCase()]);
            }
            return _defineProperty({}, kvPair[0], _getFontWeights__WEBPACK_IMPORTED_MODULE_2__/* .defaultFontWeightOptions */ .Q[kvPair[1].toLowerCase()]);
        case "fontStyle":
            return _defineProperty({}, kvPair[0], fontStyleOption[kvPair[1]]);
        case "fontFamily":
            if (kvPair[1] === "National2") {
                // add fallback-fonts and also use Wrench spelling of font: `'National 2'` vs `National2`
                return _defineProperty({}, kvPair[0], _wds_styles__WEBPACK_IMPORTED_MODULE_1__/* .WrenchTheme.type.fontFamily.base */ .Qb.type.fontFamily.base);
            }
            return _defineProperty({}, kvPair[0], kvPair[1]);
        case "textDecoration":
            return _defineProperty({}, kvPair[0], textDecorationOption[kvPair[1]]);
        case "backgroundImage":
            return kvPair[1].url ? _defineProperty({}, kvPair[0], "url(".concat(kvPair[1].url, ")")) : null;
        default:
            if (typeof kvPair[1] === "object") {
                // format nested data recursively
                return _defineProperty({}, kvPair[0], formatCommonStyle(kvPair[1]));
            }
            return _defineProperty({}, kvPair[0], kvPair[1]);
    }
};
/** Formats data recursively */ var formatCommonStyle = function formatCommonStyle(_ref10) {
    var __typename = _ref10.__typename, styles = _objectWithoutProperties(_ref10, _excluded);
    var entries = Object.entries(styles);
    return entries.reduce(function(acc, args) {
        var _ref11 = args, _ref12 = _slicedToArray(_ref11, 2), key = _ref12[0], val = _ref12[1];
        return val === null || val === undefined ? acc : _objectSpread(_objectSpread({}, acc), formatStyle([
            key,
            val
        ], styles));
    }, {});
};
/** Standardizes the formatting to be CSS/JSS compatible  */ var formatEntity = function formatEntity(data) {
    return data && formatCommonStyle(data) || undefined;
};
/** Collapses `Maybe<T>` (`T | null | undefined`) to `T | undefined` */ var defaultNullToUndefined = function defaultNullToUndefined(arg) {
    return arg === null ? undefined : arg;
};
/** Format GraphQL to Theme representation */ var formatTheme = function formatTheme() {
    var _response$survey, _artifacts$background;
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref13 = (response === null || response === void 0 ? void 0 : (_response$survey = response.survey) === null || _response$survey === void 0 ? void 0 : _response$survey.design) || {}, theme = _ref13.theme, settings = _objectWithoutProperties(_ref13, _excluded2);
    var _ref14 = theme || {}, _ref14$name = _ref14.name, name = _ref14$name === void 0 ? "Default" : _ref14$name, selectedColorPalette = _ref14.selectedColorPalette, layout = _ref14.layout, surveyPage = _ref14.surveyPage, surveyTitle = _ref14.surveyTitle, pageTitle = _ref14.pageTitle, questionTitle = _ref14.questionTitle, questionBody = _ref14.questionBody, button = _ref14.button, error = _ref14.error, exitLink = _ref14.exitLink, artifacts = _ref14.artifacts, isAccessible = _ref14.isAccessible, isCustomTheme = _ref14.isCustomTheme;
    var logo = settings.logo, progressBar = settings.progressBar;
    var surveyPageBackgroundImage = artifacts === null || artifacts === void 0 ? void 0 : (_artifacts$background = artifacts.background) === null || _artifacts$background === void 0 ? void 0 : _artifacts$background.url;
    var smFont = "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif";
    var surveyTheme = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        name: name,
        fontFamily: smFont,
        fontSize: {
            body: 16
        },
        fontWeight: _getFontWeights__WEBPACK_IMPORTED_MODULE_2__/* .defaultFontWeightOptions */ .Q,
        layout: defaultNullToUndefined(layout),
        isAccessible: isAccessible && !isCustomTheme,
        isCustomTheme: isCustomTheme,
        isDark: (0,_isDark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((selectedColorPalette === null || selectedColorPalette === void 0 ? void 0 : selectedColorPalette.primaryBackgroundColor) || "#fff"),
        surveyPage: _objectSpread(_objectSpread({}, formatEntity(surveyPage)), surveyPageBackgroundImage && {
            backgroundImage: "url(".concat(surveyPageBackgroundImage, ")")
        }),
        surveyTitle: formatEntity(surveyTitle),
        pageTitle: formatEntity(pageTitle),
        questionTitle: formatEntity(questionTitle),
        questionBody: _objectSpread({
            color: selectedColorPalette === null || selectedColorPalette === void 0 ? void 0 : selectedColorPalette.answerColor
        }, formatEntity(questionBody)),
        button: formatEntity(button),
        error: formatEntity(error),
        exitLink: formatEntity(exitLink)
    }, logo && {
        logo: formatEntity(logo)
    }), progressBar && {
        progressBar: formatEntity(progressBar)
    }), formatEntity(selectedColorPalette)), {}, {
        breakpoints: breakpoints
    });
    return surveyTheme;
}; //# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hX": function() { return /* reexport */ SurveyTheme_SurveyTheme; },
  "u7": function() { return /* reexport */ context/* useSurveyTheme */.u7; }
});

// UNUSED EXPORTS: SurveyThemeProvider, createSurveyStyles, getFontWeights, isDark, relativeLuminance, theming

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(8499);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/context.js
var context = __webpack_require__(6322);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/helpers.js
var helpers = __webpack_require__(993);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/SurveyTheme.graphql
var SurveyTheme_graphql = __webpack_require__(9177);
var SurveyTheme_graphql_default = /*#__PURE__*/__webpack_require__.n(SurveyTheme_graphql);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/SurveyTheme.js

var _jsxFileName = "/repo/packages/webassets/src/components/SurveyTheme/SurveyTheme.tsx", _this = undefined;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}





/** A simple wrapper composes inner children with the fetched theming info. */ var SurveyTheme = function SurveyTheme(_ref) {
    var children = _ref.children, surveyId = _ref.surveyId, targetEndPoint = _ref.targetEndPoint, headers = _ref.headers;
    var queryOptions = {
        variables: {
            id: surveyId
        },
        // acquire data even when an error occurs
        errorPolicy: "all",
        partialRefetch: true
    };
    // enable query context if tgtEndPoint provided
    if (targetEndPoint) {
        queryOptions.context = {};
        queryOptions.context.targetPath = "/lo-graphql/".concat(targetEndPoint);
        // include headers if provided
        if (headers) {
            queryOptions.context.headers = headers;
        }
    }
    var _useQuery = (0,react_hooks_esm/* useQuery */.aM)((SurveyTheme_graphql_default()), queryOptions), data = _useQuery.data, loading = _useQuery.loading, fetchError = _useQuery.error, refetch = _useQuery.refetch;
    /* No-op on the loading state.
   * The wrapping component should know better how to compose with a representable skeleton.
   */ if (loading) {
        return null;
    }
    var surveyTheme = (0,helpers/* formatTheme */.Qu)(data);
    return /*#__PURE__*/ react.createElement(context/* SurveyThemeProvider */.Uu, {
        theme: _objectSpread(_objectSpread({}, surveyTheme), fetchError && {
            refetch: refetch,
            fetchError: fetchError
        }),
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 62,
            columnNumber: 5
        }
    }, children);
};
/* harmony default export */ var SurveyTheme_SurveyTheme = (SurveyTheme); //# sourceMappingURL=SurveyTheme.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/getFontWeights.js
var getFontWeights = __webpack_require__(3918);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/index.js




 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 2561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export relativeLuminance */
/**
 * Relative luminance of a color
 * from http://www.w3.org/TR/WCAG20/#relativeluminancedef
 */ var relativeLuminanceInner = function relativeLuminanceInner(R8bit, G8bit, B8bit) {
    var RsRGB = R8bit / 255;
    var GsRGB = G8bit / 255;
    var BsRGB = B8bit / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbOrRgbaRegex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3}).*\)$/i;
/**
 * Convert RGB, RGBA or Hex into relative luminance
 *
 * Based on http://www.w3.org/TR/WCAG20/#relativeluminancedef
 *
 * @param rgbaOrHex RGB, RGBA or Hex color (`rgb(255,255,255)`, `rgba(255,255,255,1)`, `#FFF`, `#FFFFFF`)
 * @returns {number} number between `0` and `1`;
 */ var relativeLuminance = function relativeLuminance(rgbaOrHex) {
    var color = rgbaOrHex !== null && rgbaOrHex !== void 0 ? rgbaOrHex : "";
    var rgbMatched = (color !== null && color !== void 0 ? color : "").match(rgbOrRgbaRegex);
    if (rgbMatched) {
        return relativeLuminanceInner(parseInt("".concat(rgbMatched[1]), 10), parseInt("".concat(rgbMatched[2]), 10), parseInt("".concat(rgbMatched[3]), 10));
    }
    if (color.match(hexRegex)) {
        return relativeLuminanceInner(parseInt("".concat(color[1]).concat(color[2]), 16), parseInt("".concat(color[3]).concat(color[4]), 16), parseInt("".concat(color[5]).concat(color[6]), 16));
    }
    if (color.match(reducedHexRegex)) {
        return relativeLuminanceInner(parseInt("".concat(color[1]).concat(color[1]), 16), parseInt("".concat(color[2]).concat(color[2]), 16), parseInt("".concat(color[3]).concat(color[3]), 16));
    }
    throw Error("relativeLuminance: Invalid color format");
};
/**
 * Determines if a color is considered "dark" - as in dark theme
 *
 * @param color RGB, RGBA or Hex color (`rgb(255,255,255)`, `rgba(255,255,255,1)`, `#FFF`, `#FFFFFF`)
 * @returns {boolean} `true` if the color is considered "dark"
 */ var isDark = function isDark(color) {
    return relativeLuminance(color) < 0.5;
};
/* harmony default export */ __webpack_exports__["Z"] = (isDark); //# sourceMappingURL=isDark.js.map


/***/ }),

/***/ 9177:
/***/ (function(module) {


var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getSurveyDesign"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "survey"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "design"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "theme"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "isAccessible"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "isCustomTheme"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "layout"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "surveyPage"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "overlayColor"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "surveyTitle"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "pageTitle"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "questionTitle"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "questionBody"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "highlightColor"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "fontSize"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "fontFamily"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "fontWeight"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "fontStyle"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "textDecoration"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "error"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "button"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "exitLink"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "commonStyles"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "artifacts"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "background"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": [],
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "url"
                                                                                    },
                                                                                    "arguments": [],
                                                                                    "directives": []
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "selectedColorPalette"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "paletteColors"
                                                                        },
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "enabled"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "image"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "url"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "progressBar"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "enabled"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "position"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "showPercent"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "showPageNumber"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "paletteColors"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "ColorPalette"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "titleColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "questionColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primaryAccentColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "secondaryAccentColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primaryBackgroundColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "secondaryBackgroundColor"
                        },
                        "arguments": [],
                        "directives": []
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "commonStyles"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CommonStyle"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fontSize"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fontFamily"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fontWeight"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fontStyle"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "textDecoration"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "backgroundColor"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "backgroundImage"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "url"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 1421
    }
};
doc.loc.source = {
    "body": "query getSurveyDesign($id: ID!) {\n  survey(id: $id) {\n    id\n    design {\n      theme {\n        id\n        name\n        isAccessible\n        isCustomTheme\n        layout\n        surveyPage {\n          overlayColor\n        }\n        surveyTitle {\n          ...commonStyles\n        }\n        pageTitle {\n          ...commonStyles\n        }\n        questionTitle {\n          ...commonStyles\n        }\n        questionBody {\n          highlightColor\n          fontSize\n          fontFamily\n          fontWeight\n          fontStyle\n          textDecoration\n        }\n        error {\n          ...commonStyles\n        }\n        button {\n          ...commonStyles\n        }\n        exitLink {\n          ...commonStyles\n        }\n        artifacts {\n          background {\n            url\n          }\n        }\n        selectedColorPalette {\n          ...paletteColors\n        }\n      }\n      logo {\n        enabled\n        image {\n          url\n        }\n      }\n      progressBar {\n        enabled\n        position\n        showPercent\n        showPageNumber\n      }\n    }\n  }\n}\n\nfragment paletteColors on ColorPalette {\n  titleColor\n  questionColor\n  answerColor\n  primaryAccentColor\n  secondaryAccentColor\n  primaryBackgroundColor\n  secondaryBackgroundColor\n}\n\nfragment commonStyles on CommonStyle {\n  color\n  fontSize\n  fontFamily\n  fontWeight\n  fontStyle\n  textDecoration\n  backgroundColor\n  backgroundImage {\n    url\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.getSurveyDesign = oneQuery(doc, "getSurveyDesign");
module.exports.paletteColors = oneQuery(doc, "paletteColors");
module.exports.commonStyles = oneQuery(doc, "commonStyles");


/***/ })

}]);